import React from 'react';
import _ from 'lodash';
import { FormControl, Typography } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { RequiredField } from '../others/RequiredField';
import { InfoField } from './InfoField';
import { CssTextField } from '../others/CssTextField';
import { useDynamicAction, useDynamicQuery } from '../../services/hooks';
import { constructDependsOnParams, handleShowOn } from '../../services/functions';

export const OnChangeCharField = props => {
  const { field, type, formik, getFieldCallback, updateDiscountsCallback, historicDataByPeselCallback, allowMoreThan2PromotionsSelected } = props;
  const [val, setVal] = React.useState('');
  const action = useDynamicAction(
    field.depends_on,
    field.on_change,
    constructDependsOnParams(field.depends_on, field.name, formik.values
    ), val);
  const { query, data, loading } = useDynamicQuery(action);

  const handleChange = v => {
    formik.setFieldValue(field.name, v);
    if (field.on_change) {
      if (field.name == 'participant_pesel') {
        historicDataByPeselCallback(v);
      } else if (field.name == 'discount_code') {
        setVal(v);
        query(val, formik.values.camp, formik.values.event);
      } else {
        setVal(v);
        query(val);
      }
    }
  };

  React.useEffect(() => {
    if (_.isObject(data)) {
      if (data.request_type === 'discount') {
        const cloneDiscount = [...formik.values.discount];
        let idx = 0;
        let latestId = null;
        let latestIndex = 0;
        for (const [index, value] of cloneDiscount.entries()) {
          if (value) {
            latestId = value;
            latestIndex = index;
          }
          if (value === null) {
            idx = index;
            break;
          }
        }
        if (latestId) {
          const prom = updateDiscountsCallback(null, null, latestId);
          if (!prom.can_connect_with_other_promotions) {
            return alert('Promocja z kodu rabatowego nie łączy się z wybranymi promocjami');
          }
          if (prom.promotions_excluded_from_connecting_with) {
            if (!prom.promotions_excluded_from_connecting_with.includes(data.id)) {
              return alert('Promocja z kodu rabatowego nie łączy się z wybranymi promocjami.');
            }
          }
          if (data.promotions_excluded_from_connecting_with) {
            if (!data.promotions_excluded_from_connecting_with.includes(prom.id)) {
              return alert('Promocja z kodu rabatowego nie łączy się z wybranymi promocjami.');
            }
          }
          // if (latestIndex == 1 && !allowMoreThan2PromotionsSelected) {
          //   return alert('Możesz wybrać maksymalnie dwie promocje.');
          // }
        }
        cloneDiscount[idx] = data.id;
        formik.setFieldValue('discount', cloneDiscount);
        updateDiscountsCallback(data, cloneDiscount);
      }
    }
  }, [data]);

  return (
    <FormControl style={{ paddingBottom: 15, display: handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}
    fullWidth >
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
      </Typography>
      <CssTextField
        // debounceTimeout={1500}
        element={CssTextField}
        type={type}
        name={field.name}
        label={field.placeholder}
        value={formik.values[field.name]}
        onChange={e => handleChange(e.target.value)}
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}
        helperText={formik.touched[field.name] && formik.errors[field.name]}
        variant="outlined"

      />
      {
        !_.isEmpty(field.infos)
          ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
          : null
      }
    </FormControl>
  );
};
